/**
 * Per-domain default UI language override.
 *
 * When several hostnames map to the same silo (e.g. `dialogue.rts.ch`,
 * `dialog.srf.ch`, `dialogo.rsi.ch` all serving the SRG silo), the silo-wide
 * `defaultLanguage` cannot distinguish between them. This map lets a deployment
 * pick a per-domain default that wins over `siloConfig.defaultLanguage` and
 * `deploymentConfig.defaultLanguage`, but stays below `?language_g=` URL
 * overrides in the precedence chain (see `useSiloLanguage` in
 * `system/request-metadata`).
 *
 * Keys are matched against `getDomain()` (`util/util.ts`) — the same lookup
 * `getDeploymentConfig` uses — so `'localhost'` and `'test'` are valid keys for
 * local dev and test setups. Matching is exact (no wildcards / suffixes).
 *
 * Empty by default — partners add their own domain → language pairs as needed.
 *
 * This module is intentionally side-effect-free so it can be imported from
 * Node-side build scripts (e.g. `scripts/inject-html-lang.ts`) without
 * triggering the `window.location.*` and `require('./assets/*.svg')` references
 * that `psi.config.ts` carries at top level. `psi.config.ts` re-exports
 * `domainToLanguageMap` from here so existing imports stay unchanged.
 */
import { type IsoLocale } from '@repo/shared/locale';

export const domainToLanguageMap: Record<string, IsoLocale> = {
    'psi.kika.de': 'de-DE',
};
